import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {css} from '@emotion/core'
import {themes} from '../util/theme'

import HamburgerButton from '../images/hamburger-button.svg'
import {getStartpageBaseOrigin} from '../util/url'
import HamburgerSection from './hamburger/HamburgerSection'

const HamburgerMenu = ({links, theme, themeStyles, lang = `en`, icon}) => {
    const baseOrigin = getStartpageBaseOrigin()
    const {whiteFilter} = themeStyles

    const [showMenu, setShowMenu] = useState(false)

    const toggleMenu = (show) => {
        setShowMenu(show)
        if (showMenu) {
            setShowMenu(false)
        } else {
            setShowMenu(true)
        }
    }

    const animateInStyles = `
        .hamburger-menu-mask {
            display: block;
            opacity: 1;
        }
        .hamburger-menu-shelf {
            right: 0;
        }
    `

    const animateOutStyles = `
        .hamburger-menu-mask {
            display: none;
            opacity: 0;
        }
        .hamburger-menu-shelf {
            right: -294px;
            @media (max-width: 990px) {
                right: -330px;
            }
        }
    `
    return (
        <div
            className="hamburger-menu"
            css={css`
                margin-top: 5px;
            `}
        >
            <button
                className="hamburger-button"
                aria-label="hamburger menu"
                type="button"
                onClick={toggleMenu}
                css={css`
                    background: none;
                    outline: none;
                    border: none;
                    filter: ${whiteFilter};
                    &:hover {
                        cursor: pointer;
                    }
                    svg {
                        fill: ${themeStyles.headerLinkColor};
                    }
                `}
            >
                {icon || <HamburgerButton />}
            </button>
            <div
                className="hamburger-menu-container"
                css={css`
                    ${showMenu ? animateInStyles : animateOutStyles}
                `}
            >
                <div
                    className="hamburger-menu-shelf"
                    css={css`
                        z-index: 999;
                        padding: 56px 32px 24px;
                        background: ${themeStyles.primaryBackgroundColor};
                        position: fixed;
                        top: 0;
                        right: -260px;
                        height: 100%;
                        width: 294px;
                        max-width: 80vw;
                        transition: right 0.2s ease;
                        overflow-y: scroll;
                        scrollbar-width: none;
                        -ms-overflow-style: none;
                        &::-webkit-scrollbar {
                            display: none;
                        }
                        @media (max-width: 990px) {
                            width: 330px;
                            right: -330px;
                        }
                    `}
                >
                    <div
                        css={css`
                            position: absolute;
                            top: 20px;
                            right: 20px;
                            width: 20px;
                            height: 20px;
                            background: url(${baseOrigin}/sp/cdn/images/grey-x.svg) 50% 50% no-repeat;
                            cursor: pointer;
                        `}
                        className="x-button"
                        onClick={() => setShowMenu(false)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                setShowMenu(false)
                            }
                        }}
                        role="button"
                        tabIndex={showMenu ? 0 : -1}
                        aria-label="close hamburger menu"
                    />
                    <div>
                        {links?.map(({sectionTitle, linkData}, i) => {
                            return (
                                <HamburgerSection
                                    key={i}
                                    sectionTitle={sectionTitle}
                                    linkData={linkData}
                                    theme={theme}
                                    themeStyles={themeStyles}
                                    lang={lang}
                                    setShowMenu={setShowMenu}
                                />
                            )
                        })}
                    </div>
                </div>
                <div
                    className="hamburger-menu-mask"
                    css={css`
                        position: fixed;
                        z-index: 998;
                        top: 0;
                        left: 0;
                        background: rgba(0, 0, 0, 0.5);
                        height: 100%;
                        width: 100%;
                        transition: opacity 0.2s ease;
                    `}
                    role="button"
                    aria-label="hamburger menu button"
                    onClick={toggleMenu}
                    onKeyUp={toggleMenu}
                    tabIndex="0"
                />
            </div>
        </div>
    )
}

HamburgerMenu.propTypes = {
    links: PropTypes.array,
    theme: PropTypes.string,
    themeStyles: PropTypes.object,
    lang: PropTypes.string,
    icon: PropTypes.node,
}

HamburgerMenu.defaultProps = {
    links: [
        {text: `Settings`, url: `https://www.startpage.com/search/settings?lang=en`},
        {text: `Support`, url: `https://support.startpage.com/index.php?/Knowledgebase/List`},
        {text: `Privacy policy`, url: `/en/privacy-policy/`},
        {text: `About Us`, url: `/en/about-us/`},
        {text: `Blog`, url: `https://www.startpage.com/privacy-please/`},
        {text: `Press`, url: `https://www.startpage.com/privacy-please/press/`},
    ],
    theme: `light`,
    themeStyles: themes.light,
}

export default HamburgerMenu
